import * as React from 'react';
import { Translate } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import NotificationPopup from '../NotificationPopup';

interface AnotherUserLoginPopupProps {
	isDisplayed: boolean;
	dispatch: Dispatch<StoreState>;
}

const AnotherUserLoginPopup = ({ isDisplayed, dispatch }: AnotherUserLoginPopupProps) => (
	<NotificationPopup
		isDisplayed={isDisplayed}
		dispatch={dispatch}
	>
		<Translate value="error.another_user_login" />
	</NotificationPopup>
);

export default AnotherUserLoginPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MultiAppAuthentication/AnotherUserLoginPopup/index.tsx